import {
  Container,
  Space,
  Title,
  Card,
} from "@mantine/core";
import React from "react";
import { ChangePassword } from "./ChangePassword";
import { DeleteAccount } from "./DeleteAccount";

function ProfilePage(props:any): JSX.Element {
  return (
    <React.Fragment>
      <Container fluid>
        <Space h="lg" />
        <Title order={2}>Profile</Title>
        <Space h="lg" />
        <Card withBorder shadow="sm" radius="md">
          <Card.Section withBorder inheritPadding mt="sm" pb="md">
            <ChangePassword />
          </Card.Section>
        </Card>
        <DeleteAccount />
      </Container>
    </React.Fragment>
  );
}

export { ProfilePage };
